import { StorageServices } from '@/services/StorageServices';
import { createStore } from 'vuex'
import * as OM from '@/model';
import * as VM from '@/viewmodel';
import * as Enum from '@/enum';
import * as env from '@/config';

let vuestore = {
    state: {
        env: env,
        loginData: <OM.LoginData>null,
        user: <OM.Lead>null,
        selectedLanguage: "",
        consts: {
            localizedValues: [],
            enabledLanguages: [],
            projectConfig: <OM.ProjectConfigVm>{
                name: "",
                colors: new OM.ProjectColors(),
                logoUrl: "",
                siteUrl: ""
            },
        },
        paymentConfig: <OM.PaymentConfigVm>null,
        showSpinner: 0,
        isMobile: false,
        newNotificationCount: 0,
        beforeNavCbs: [],
        afterNavCbs: [],
        systemCopy: copyToClipboard,
        hasNewMessages: false,
        notification: null,
        isCordova: false,
        hasModule: (value: string) => {
            return store.state.consts.projectConfig.modules.some(x => x.name == value);
        },
        hasDashboardModule: (value: string) => {
            return store.state.consts.projectConfig.dashboardModules.some(x => x == value);
        },
        notificationCallback: (payload: any) => {
            console.log("notification received", payload);
        },
        formErrors: <{ [key: string]: boolean }>{},
        backButtonFunction: null,
        openBrowser: ($event) => {
            let findParentWithHref = (element) => {
                if (element.href) {
                    return element.href;
                } else if (element.parentElement) {
                    return findParentWithHref(element.parentElement);
                }
                return null;
            };
        
            let url;
            if ($event.target) {
                $event.preventDefault();
                url = findParentWithHref($event.target);
            } else {
                url = $event;
            }
        
            if (url) {
                if (!window.cordova) {
                    window.open(url, "_blank");
                } else {
                    window.cordova.InAppBrowser.open(url, "_system");
                }
            } else {
                console.error("Nessun URL trovato nell'elemento o nei suoi parent.");
            }
        },
        isLead: (role?: string) => {
            let checkWith = role ? role : vuestore.state.user && vuestore.state.user.role;
            return checkWith == Enum.UserRoles.Lead;
        },
        isCliente: (role?: string) => {
            let checkWith = role ? role : vuestore.state.user && vuestore.state.user.role;
            return checkWith == Enum.UserRoles.Cliente;
        },
        isCollaboratore: (role?: string) => {
            let checkWith = role ? role : vuestore.state.user && vuestore.state.user.role;
            return checkWith == Enum.UserRoles.Collaboratore;
        },
        isCentro: (role?: string) => {
            let checkWith = role ? role : vuestore.state.user && vuestore.state.user.role;
            return checkWith == Enum.UserRoles.CentroFumo;
        },
        isManager: (role?: string) => {
            let checkWith = role ? role : vuestore.state.user && vuestore.state.user.role;
            return checkWith == Enum.UserRoles.Manager; 
        },
        isAdmin: (role?: string) => {
            let checkWith = role ? role : vuestore.state.user && vuestore.state.user.role;
            return checkWith == Enum.UserRoles.Admin;
        },
    }
}

vuestore.state.isCordova = !!window.cordova;
vuestore.state.isMobile = window.innerWidth <= 768;
window.addEventListener('resize', () => {
    store.state.isMobile = window.innerWidth <= 768;
})

let store = createStore(vuestore);
export default store


function copyToClipboard(text, clickEv: MouseEvent = null) {
    var dummy = document.createElement("textarea");
    // to avoid breaking orgain page when copying more words
    // cant copy when adding below this code
    // dummy.style.display = 'none'
    document.body.appendChild(dummy);
    //Be careful if you use texarea. setAttribute('value', value), which works with "input" does not work with "textarea". – Eduard
    dummy.value = text;
    dummy.select();
    document.execCommand("copy");
    document.body.removeChild(dummy);
    
    if(clickEv){
        var popup = document.createElement("div");
        popup.style.position = "fixed";
        popup.style.left = clickEv.clientX - 25 + "px";
        popup.style.top = clickEv.clientY - 25 + "px";
        popup.style.backgroundColor = "transparent";
        popup.style.border = "none";
        popup.style.pointerEvents = "none";
        popup.style.touchAction = "none";
        popup.innerHTML = '<img src="' + require('@/img/common/check.png') + '" />'; // "<img src=\"https://upload.wikimedia.org/wikipedia/commons/thumb/e/e9/Check_mark.svg/220px-Check_mark.svg.png\" />";
        document.body.append(popup);
        setTimeout(() => {
            popup.remove();
        }, 800);
    }

}